import React from "react";
import { NodeProps } from "@xyflow/react";
import classNames from "classnames";
import { useEntities } from "@hooks/useEntities";
import { ConsolidatedAvatar } from "@components/avatar/ConsolidatedAvatar";
import { OwnershipGroupHeaderNode } from "../ownership.types";
import styles from "./GroupHeaderNode.module.scss";

/**
 * The consolidated pill is rendered as its own high-z node (rather than inside
 * the boundary node) so it paints above ownership edges: an edge into a grouped
 * member is auto-elevated to the member's z, which sits one above the boundary,
 * so a pill kept inside the boundary would always be bisected by that edge.
 */
export const GroupHeaderNode: React.FC<NodeProps<OwnershipGroupHeaderNode>> =
    React.memo(({ data }) => {
        const entities = useEntities();
        const { group, isSelected, onSelect } = data;

        const parentEntity = entities.find(
            (entity) => entity.uuid === group.parentEntityUuid,
        );
        const entityName = parentEntity?.name ?? "Group";

        return (
            <div className={styles.container}>
                <div
                    className={classNames("nodrag", "nopan", styles.pill, {
                        [styles.pillSelected]: isSelected,
                    })}
                    onMouseDown={(event) => {
                        event.stopPropagation();
                        onSelect();
                    }}
                    onClick={(event) => {
                        event.stopPropagation();
                    }}
                >
                    <ConsolidatedAvatar
                        name={entityName}
                        size="xs"
                        aria-hidden
                    />
                    <span className={styles.label}>
                        {entityName} (Consolidated)
                    </span>
                </div>
            </div>
        );
    });
GroupHeaderNode.displayName = "GroupHeaderNode";
